import { connect } from "react-redux";
import { Close as CloseIcon } from "@mui/icons-material";

import { logout, sessionExpiredFalse } from "../../redux/auth";
import Modal from "../Modal";
import { Button, HeaderModal, SessionExpiredContent } from "./styles";

const SessionExpiredModal = ({
  sessionExpired,
  dispatch
}) => {
  const handleToLoginScreen = () => {
    dispatch(sessionExpiredFalse());
    dispatch(logout());
    history.push('/');
  }

  const renderHeader = () => {
    return (
      <HeaderModal>
        <span>
          Sessão expirada
        </span>
        <CloseIcon 
          sx={{cursor: 'pointer'}} 
          onClick={handleToLoginScreen} 
          htmlColor="#fff" 
        />
      </HeaderModal>
    );
  }


  return (
    <>
      {sessionExpired && (
        <Modal
          size="small"
          renderHeader={renderHeader()}
          onBackdropClick={handleToLoginScreen}
        >
          <SessionExpiredContent>
            <span>
              Sua sessão expirou. Para continuar acessando a plataforma, você precisará refazer o login.
            </span>
      
            <Button 
              skin="primary"
              onClick={handleToLoginScreen}
            >
              LOGIN
            </Button>
          </SessionExpiredContent>
        </Modal>   
      )}
    </>
  )  
}

const mapStateToProps = state => ({
  sessionExpired: state.auth.sessionExpired,
});


export default connect(mapStateToProps)(SessionExpiredModal);
